import { render } from "./ActivityLogsList.vue?vue&type=template&id=7653d9f0"
import script from "./ActivityLogsList.vue?vue&type=script&lang=js"
export * from "./ActivityLogsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__